import React, { useContext, useEffect, useRef, useState } from "react";
import Section1 from "../../components/section1/index";
import Assignmenthelp from "../../components/assignmenthelp/assignmenthelp";
import CarouselComponent from "../../components/assignmentTypes/assignmentTypes";
import Bestquality from "../../components/bestQuality/Bestquality";
import FaqSection from "../../components/faqs/Faqs";
import FeedbackCarousel from "../../components/feedbacks/Feedbacks";
import Writingtools from "../../components/writingtools/Writingtools";
import ChatBot from "../../components/chatbot/Chatbot";
import Section2 from "../../components/section2/index";
import WhatsAppChat from "../../components/whatsAppChat/WhatsApp";
import HomeSectionOne from "../HomeSectionOne/HomeSectionOne";
import axios from "axios";


const Homepage = () => {
  const section2Ref = useRef(null);
  const feedbackRef = useRef(null);
  const faqsRef = useRef(null);
  const footerSubsRef = useRef(null);
  const [country, setCountry] = useState(""); // State to store the user's country

  const [error, setError] = useState(null);  // State to handle errors

  const getLocation = async () => {
    try {
      const response = await axios.get("http://ip-api.com/json");
      await setCountry(response.data.country); // Extract and set the country
    } catch (error) {
      setError("Unable to fetch location."); // Handle errors
      console.error("Error fetching location:", error);
    }
  };

  useEffect(() => {
    getLocation(); // Fetch location when the component mounts
  }, []);
  // Store reference in localStorage for Footer to access
  useEffect(() => {
    window.section2Ref = section2Ref;
    window.feedbackRef = feedbackRef;
    window.faqsRef = faqsRef;
    window.footerSubsRef = footerSubsRef;

  }, []);



  return (
    <>
      <div>
        {/* <Section1 /> */}
        <HomeSectionOne country={country} />
      </div>
      <div ref={section2Ref}>
        <Section2 country={country} />
      </div>
      <Assignmenthelp />
      <CarouselComponent />
      <Bestquality />
      {/* <Writingtools /> */}
      <div ref={feedbackRef}>
        <FeedbackCarousel />
      </div>
      <div ref={faqsRef}>
        <FaqSection />
      </div>

    </>
  );
};

export default Homepage;
